import { useContext, useState } from "react";
import axios from "axios";
import logo from "../assets/images/logo.png";
import { Link } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import Modal from "./Modal";
import TermsAndConditions from "./TermsAndConditions";
const Register = () => {
  const { authState } = useContext(AuthContext);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    password: "",
    role: "primary", // Default role set to 'primary' for initial registration change as needed for admin role is "admin"
  });
  const [message, setMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("text-center text-success");
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Check if user exists
      const checkRes = await axios.post(
        `${process.env.REACT_APP_API_DOMAIN ?? ""}/api/auth/check-user`,
        {
          email: formData.email,
          mobile: formData.mobile,
        }
      );

      if (checkRes.data.exists) {
        setMessage("User already exists with this email or mobile number.");
        setErrorMessage("text-center text-success");
        return; // Stop further execution if the user already exists
      }
      // Proceed to register the user if no conflict
      const res = await axios.post(
        `${process.env.REACT_APP_API_DOMAIN ?? ""}/api/auth/register`,
        formData
      );

      setMessage(res.data.message);
      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        mobile: "",
        password: "",
        role: "primary",
      });

      // Optionally redirect to login
      window.location.href = "/login";
    } catch (error) {
      setMessage(
        error.response?.data?.error || "An error occurred during registration."
      );
      setErrorMessage("alert alert-danger");
    }
  };

  return (
    <div className="bg-image d-flex align-items-center justify-content-center vh-100 bg-light reg-pg">
      <div className="card shadow p-4 boxbg" style={{ width: "400px" }}>
        <div className="bg-overlay"></div>
        <div className="cont-int text-white">
          <div className="text-center mb-2">
            <Link className="navbar-brand text-center" to="/home">
              <img width="100" src={logo} alt="Logo" />
            </Link>
          </div>
          <h5 className="card-title text-center mb-2 text-uppercase">
            Register your account
          </h5>
          {message && <p className={errorMessage}>{message}</p>}
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label htmlFor="firstName" className="form-label">
                First Name
              </label>
              <input
                type="text"
                className="form-control"
                id="firstName"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="lastName" className="form-label">
                Last Name
              </label>
              <input
                type="text"
                className="form-control"
                id="lastName"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="email" className="form-label">
                Email
              </label>
              <input
                type="email"
                className="form-control"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="mobile" className="form-label">
                Mobile
              </label>
              <input
                type="text"
                className="form-control"
                id="mobile"
                name="mobile"
                maxLength={10}
                value={formData.mobile}
                onChange={handleChange}
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="password" className="form-label">
                Password
              </label>
              <input
                type="password"
                className="form-control"
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
              />
            </div>
            <button
              type="submit"
              className="btn btn-primary w-100"
              disabled={!acceptedTerms}
            >
              Register
            </button>
            <div className="mt-2">
              <input
                type="checkbox"
                className="form-check-input me-2"
                id="terms"
                checked={acceptedTerms}
                onChange={() => setAcceptedTerms(!acceptedTerms)}
              />
              <label className="form-check-label" htmlFor="terms">
                I accept the{" "}
                <span onClick={openModal} className="loglink cursor">
                  Terms and Conditions
                </span>
              </label>
            </div>
          </form>
          <Modal
            showModal={showModal}
            onClose={closeModal}
            pageTitle="Terms and Conditions"
          >
            {/* <Register referralId={userData.id} pageTitle="Add New Member" /> */}
            <TermsAndConditions />
          </Modal>
          <p className="text-center mt-3">
            If you have an account?{" "}
            <Link to="/login" className="text-decoration-none loglink">
              Sign in
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Register;
